import React from "react";
import { Box, Typography } from "@mui/material";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { makeStyles } from "@mui/styles";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";

const Why = () => {
	const classes = useStyles();

	return (
		// <>
		// 	<Box
		// 		sx={{
		// 			width: 1,
		// 			display: "flex",
		// 			alignItems: "center",
		// 			flexDirection: "column",
		// 			// backgroundImage: `url("https://images.unsplash.com/photo-1557683316-973673baf926?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2029&q=80")`,
		// 		}}
		// 	>
		// 		<Box
		// 			maxWidth="md"
		// 			sx={{
		// 				py: 10,
		// 				display: "flex",
		// 				flexDirection: "column",
		// 				alignItems: "center",
		// 			}}
		// 		>
		// 			<Box className={classes.questionLeft} sx={{ mb: 2 }}>
		// 				My hand sanitizer gives me headache.
		// 			</Box>
		// 			<Box className={classes.questionRight} sx={{ mb: 2 }}>
		// 				There are so many kinds of sanitizers. I don't know what to choose.
		// 			</Box>
		// 			<Box className={classes.questionLeft} sx={{ mb: 2 }}>
		// 				Sanitizers I have makes my hand dry.
		// 			</Box>
		// 			<Box className={classes.questionRight} sx={{ mb: 2 }}>
		// 				I am worrying about environment since wipes are incorruptible.
		// 			</Box>

		// 			<LazyLoadImage
		// 				width="600"
		// 				height="250"
		// 				alt=""
		// 				src={"/img/why1.png"}
		// 			/>
		// 		</Box>
		// 	</Box>
		// 	<Box
		// 		sx={{
		// 			width: 1,
		// 			display: "flex",
		// 			alignItems: "center",
		// 			flexDirection: "column",
		// 		}}
		// 	>
		// 		<Box
		// 			maxWidth="md"
		// 			sx={{
		// 				py: 10,
		// 				display: "flex",
		// 				flexDirection: "column",
		// 				alignItems: "center",
		// 			}}
		// 		>
		// 			{/* <Box>
		// 				<LazyLoadImage
		// 					width="600"
		// 					height="250"
		// 					alt=""
		// 					src={"/img/why1.png"}
		// 				/>
		// 			</Box> */}
		// 		</Box>
		// 	</Box>
		// </>
		<>
			<div
				style={{
					width: "100%",
					height: "400px",
					color: "white",
					backgroundRepeat: "none",
					backgroundSize: "cover",
					backgroundPosition: "right 35% bottom 25%",
					// backgroundImage: `url("https://images.unsplash.com/photo-1469050624972-f03b8678e363?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80")`,
					// backgroundImage: `url("https://images.unsplash.com/photo-1586162544865-6878ac726bba?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80")`,
					backgroundImage: `url("https://images.unsplash.com/photo-1585816805333-0651801e4ebf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80")`,
					display: "flex",
					alignItems: "center",
				}}
			>
				<Box sx={{ fontSize: "20px", pl: 10 }}>
					<Typography
						sx={{ display: "flex", alignItems: "center", fontSize: "23px" }}
					>
						<BookmarkAddedIcon sx={{ color: "#36b4e6" }} />
						<Box sx={{ pt: 1, pl: 1 }}>
							No harmful chemical for you and your family
						</Box>
					</Typography>
					<Typography variant="h4" sx={{ pt: 2 }}>
						Meet our New Nano Technology
					</Typography>
					<Typography sx={{ fontSize: "17px", pt: 1, color: "white" }}>
						All products are made in South Korea.
					</Typography>
				</Box>
			</div>

			<Box
				sx={{
					width: 1,
					display: "flex",
					alignItems: "center",
					flexDirection: "column",
				}}
			>
				<Box
					maxWidth="md"
					sx={{
						py: 10,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
				>
					<Box className={classes.questionLeft} sx={{ mb: 2 }}>
						My hand sanitizer gives me headache.
					</Box>
					<Box className={classes.questionRight} sx={{ mb: 2 }}>
						There are so many kinds of sanitizers. I don't know what to choose.
					</Box>
					<Box className={classes.questionLeft} sx={{ mb: 2 }}>
						Sanitizers I have makes my hand dry.
					</Box>
					<Box className={classes.questionRight} sx={{ mb: 2 }}>
						I am worrying about environment since wipes are incorruptible.
					</Box>

					<LazyLoadImage
						width="600"
						height="250"
						alt=""
						src={"/img/why1.png"}
					/>
				</Box>
			</Box>
			<Box
				sx={{
					width: 1,
					display: "flex",
					alignItems: "center",
					flexDirection: "column",
				}}
			>
				<Box
					maxWidth="md"
					sx={{
						py: 10,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
				>
					{/* <Box>
						<LazyLoadImage
							width="600"
							height="250"
							alt=""
							src={"/img/why1.png"}
						/>
					</Box> */}
				</Box>
			</Box>
		</>
	);
};

export default Why;
const useStyles = makeStyles({
	questionLeft: {
		border: "2px solid #e7f5ff",
		borderRadius: "50px",
		padding: "20px",
		marginRight: "auto",

		backgroundColor: "#e7f5ff",
	},
	questionRight: {
		border: "2px solid #e7f5ff",
		borderRadius: "50px",
		padding: "20px",
		marginLeft: "auto",

		backgroundColor: "white",
	},
});
